/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { QuestionSetComponent } from '@xengage/gw-portals-questionsets-ui';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { GatewayRenewalService as RenewalService } from 'gw-capability-gateway-policyrenewal';
import _ from 'lodash';
import React, { useCallback, useContext, useState, useMemo } from 'react';
// import PrintDocumentUtil from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js';
import { InlineNotification, Loader, useModal } from '@jutro/components';
import CustomLoader from "producer-engage/src/components/CustomLoader/CustomLoader.jsx";
import { useTranslator } from '@jutro/locale';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
import { ENTDdocumentUploadComponent } from 'gw-capability-gateway-react';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';

import metadata from './AdditionalInformationPage.metadata.json5';
import  './AdditionalInformationPage.messages.js';
import styles from './AdditionalInformationPage.module.scss';

import AdditionalInterestComponent from '../../components/AdditionalInformation/AdditionalInterestComponent/AdditionalInterestComponent.jsx';
import AdditionalInsuredComponent from '../../components/AdditionalInformation/AdditionalInsuredComponent/AdditionalInsuredComponent.jsx';

const LOB_PATH = {
    PersonalAuto: 'lobData.personalAuto.preQualQuestionSets.children[0].value',
    Homeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    HOPHomeowners: 'lobData.homeowners.preQualQuestionSets.children[0].value',
    BusinessOwners:
        'lobData.businessOwners.preQualQuestionSets.children[0].value',
    BusinessAuto:
        'lobData.businessOwners.preQualQuestionSets.children[0].value',
};

function TWIAAdditionalInformationPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const { showAlert, showConfirm, showModal } = useModal();
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const [errorSets, setErrorSets] = useState([]);
    const { refreshData } = useDataRefresh();
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';
    const jobNumber = isRenewal ? _.get(submissionVM, 'jobID.value') : _.get(submissionVM, 'quoteID.value');
    const jobType = _.get(submissionVM, 'baseData.jobType.value.code');
    const productCode = _.get(submissionVM, 'baseData.productName.value');
    const uwCompany = 'twia';

    const {
        // registerInitialComponentValidation,
        // isComponentValid,
        initialValidation,
        onValidate,
        onResolve,
        onAfterClose
    } = useValidation('TWIAAdditionalInformationPage');

    // eslint-disable-next-line consistent-return
    const getErrorMessages = useCallback((validationIssues) => {
        if (validationIssues && (validationIssues.issues && validationIssues.issues.length > 0)) {
            let errorReasons = [];

            if (validationIssues.issues && validationIssues.issues.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                errorReasons = validationIssues.issues.filter((item) => _.isUndefined(item.flowStepId)).map((item, index) => item.reason);
            }

            refreshData();

            const errormessages = [...errorReasons];

            if (errormessages.length > 0) {
                setErrorSets(errormessages);
                return true;
            }

            if (errormessages.length === 0) {
                setErrorSets([]);
                return false;
            }
        } else {
            refreshData();
            return false;
        }

    }, [setErrorSets, refreshData]);
    
    const resetElectronicPaymentData = useCallback(() => {
        const epayData = _.get(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA');

        if (epayData && epayData.aspects && !epayData.aspects.subtreeValid) {
            _.set(submissionVM, 'bindData.paymentDetails.electronicPaymentData_TWIA.value', null);
            updateWizardData(submissionVM);
        }
    }, [submissionVM, updateWizardData]);
    
    const onNext = useCallback(async () => {

        const phoneType = _.get(submissionVM, 'baseData.accountHolder.primaryPhoneType.value.code');
        const homeCode = _.get(submissionVM, 'baseData.accountHolder.homeNumber.value');
        const workCode = _.get(submissionVM, 'baseData.accountHolder.workNumber.value');
        const cellCode = _.get(submissionVM, 'baseData.accountHolder.cellNumber.value');

         // DE18686
        if (phoneType === 'home' && homeCode === undefined) {
            _.unset(submissionVM.value, 'baseData.accountHolder.primaryPhoneType')
        } else if (phoneType === 'work' && workCode === undefined) {
            _.unset(submissionVM.value, 'baseData.accountHolder.primaryPhoneType')
        } else if (phoneType === 'mobile' && cellCode === undefined) {
            _.unset(submissionVM.value, 'baseData.accountHolder.primaryPhoneType')
        }

        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        setShowErrors(false);

        try {

            if (isRenewal) {
                submissionVM.validationParams_TWIA.value = {
                    validationLevel: 'default',
                    validationWizardStep: 'AdditionalInfo',
                    skipAllValidation: false
                };
                resetElectronicPaymentData();
                submissionVM.value = await RenewalService.updateQuotedRenewal(
                    [submissionVM.value],
                    authHeader
                )
            } else {
                resetElectronicPaymentData();
                submissionVM.value = await LoadSaveService.updateQuotedSubmission(
                    submissionVM.value,
                    authHeader
                );
            }

            if (submissionVM.value.errorsAndWarnings) {
                const result = getErrorMessages(submissionVM.value.errorsAndWarnings.validationIssues);

                if (result === false) {
                    setShowErrors(false);
                } else {
                    setShowErrors(true)

                    return false;
                }
            }

            return submissionVM;
        } catch (error) {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);

            return false;
        }
    }, [LoadSaveService, authHeader, getErrorMessages, invalidComponent?.length, isRenewal, resetElectronicPaymentData, showAlert, submissionVM]);

    const errorContent = useCallback(
        item => (
                <InlineNotification id={item} 
                message={item}
                type= "error"
                className= {styles.marginBottom}
                isDismissable= {false}
                />
            ),
        []
    );
    
    const generateOverrides = useMemo(() => {
        const overrides = errorSets.map((item, index) => ({
                [`errorMsg${index}`]: {
                    content: errorContent(item),
                },
            }));
        
        return Object.assign({}, ...overrides);
    }, [errorSets, errorContent]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        setShowErrors(false);
        
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    // const quotePrintDocument = useCallback(async () => {   
    
    //     setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);
       
    // }, [authHeader, showAlert, showConfirm, submissionVM, translator])


    const quotePrintDocument = useCallback(() => {
        
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const overrideProps = {
        '@field': {
            // apply to all fields
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        questionSets: {
            path: LOB_PATH.Homeowners,
        },
        AdditionalInterests: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        AdditionalInsureds: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate
        },
        additionalInterestsAccordion: {
            errorState: _.includes(invalidComponent, 'AdditionalInterestDetails') && showErrors
        },
        additionalInsuredsAccordion: {
            errorState: _.includes(invalidComponent, 'AdditionalInsuredDetails') && showErrors
        },

        // 2025-05-22 - Debra Frum - DE19212 - TWIA Underwriting Response activities are triggering under open transactions
        //   Functionality for TWIA didn't get implemented when TFPA & TWIA portals merged during move to Guidewire Cloud
        // 2022-05-24 - Debra Frum - US22167 - PC / PE Underwriting Response Activity
        //   Don't create a Review activity when a document is uploaded within a TWIA transaction workflow
        uploadDocumentsDetails: {
            jobNumber, jobType, productCode, uwCompany, skipReviewActivity: true
        },
        infoMessage: {
            data: errorSets
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        },
        ...generateOverrides,    
        
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: { 
            questionset: QuestionSetComponent,
            AdditionalInterestsComponent: AdditionalInterestComponent,
            AdditionalInsuredsComponent: AdditionalInsuredComponent ,
            documentUploadComponent: ENTDdocumentUploadComponent,
            customLoader: CustomLoader
        },
        resolveCallbackMap: {
            quotePrintDocument
           // onValidate: onValidate,
        },
    };

    return (
      
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    showErrors={showErrors}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </Loader>
        </WizardPage>
    );
}

TWIAAdditionalInformationPage.propTypes = wizardProps;
export default TWIAAdditionalInformationPage;
